export default __webpack_public_path__ + "static/media/my-kwee-zeen-sofitel-kuala-lumpur-damansara.50ac054e.jpg";